import "./plugins/dialog";
import "./plugins/select2";
import "./plugins/tippy";
import "./plugins/flatpickr";
import "./plugins/sal";
import "./utils/smooth-scroll";
import "./components/navigation";
import "./components/submenu";
import "./components/timeline";
import "./components/irobot-family";
import "./components/instafeed";
import "./components/media-text";
import "./components/product-interact";
import "./components/references";
import "./components/number-input";
import "./components/stars-rating-input";
import "./components/file-input";
import "./components/form-pros-cons";
import "./components/dropdown-select";
import "./components/tabs";
import "./components/smoothScroll";
import "./components/diff-table";
import "./components/floating-news";
import "./components/scrollStarted";
import Accordions from "a11y-accordion-component";

import "./components-ipress/ajaxForm-stars";
import "./components-ipress/ajaxForm-rating-product";
import "./components-ipress/ajaxForm-newsletter";
import "./components-ipress/ajaxForm";
import "./components-ipress/formToggle";
import "./components-ipress/compare";
import "./components-ipress/configurator";
import "./components-ipress/submenu-hover";
import "./components-ipress/modules";
import "./components-ipress/gmap";
import "./components-ipress/woo-addtocart";
import "./components-ipress/woo-removefromcart";
import "./components-ipress/woo-updatecartquantity";
import "./components-ipress/woo-checkout";

Accordions.init();
console.log("Hello irobot!");
